module.exports = __webpack_public_path__ + "ac40fbbd2a46e958e19b44e469a50b33.png";